// https://github.com/rcdexta/react-trello/issues/340#issuecomment-704796291

import React from 'react'

export const LaneScrollContext = React.createContext({ min: 0, max: Infinity })
